"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogoPayPoWhite = exports.LogoPayPo = exports.IconLinkedIn = exports.IconInstagram = exports.IconFacebook = exports.ButtonLoader = exports.ArrowRight = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var LogoPayPo = function LogoPayPo(props) {
  return _react["default"].createElement("svg", props, _react["default"].createElement("g", {
    clipPath: "url(#a)"
  }, _react["default"].createElement("path", {
    d: "M140.3 159.1h-60v59.5h60v-59.5Z",
    fill: "#A70584"
  }), _react["default"].createElement("path", {
    d: "M140 78.4H80v60h60v-60Z",
    fill: "#36B587"
  }), _react["default"].createElement("path", {
    d: "M60 158.4H0v60h60v-60Z",
    fill: "#FAD05B"
  }), _react["default"].createElement("path", {
    d: "M319.1 74.6c0 41.4-33.3 74.6-76.2 74.6h-32.7v68.4h-49.8V0h82.4c43.1 0 76.3 33.3 76.3 74.6Zm-49.7 0c0-15.9-11.2-28-26.4-28h-32.7v56H243c15.2 0 26.4-12.1 26.4-28ZM492.7 58v159.6h-47.9v-15c-10.5 12.1-26.2 19.5-47.6 19.5-41.8 0-76.3-36.7-76.3-84.3 0-47.6 34.5-84.3 76.3-84.3 21.4 0 37 7.3 47.6 19.5V58h47.9Zm-47.9 79.8c0-23.9-16-38.9-38-38.9s-38 15-38 38.9 16 39 38 39 38-15.1 38-39ZM674.6 58l-54.2 153.8c-17.8 50.4-46 70.4-90.4 68.2v-44.4c22.2 0 32.7-7 39.6-26.3L506.6 58h52.3l35.2 97L624 58h50.6ZM851.9 74.6c0 41.4-33.3 74.6-76.2 74.6H743v68.4h-49.8V0h82.4c43 0 76.3 33.3 76.3 74.6Zm-49.7 0c0-15.9-11.2-28-26.4-28h-32.7v56h32.7c15.2 0 26.4-12.1 26.4-28ZM858.2 140c0-46.3 36.7-82.1 82.4-82.1S1023 93.6 1023 140c0 46.4-36.7 82.1-82.4 82.1s-82.4-35.8-82.4-82.1Zm118.1 0c0-22.1-15.5-36.7-35.8-36.7-20.2 0-35.8 14.6-35.8 36.7s15.5 36.7 35.8 36.7c20.3 0 35.8-14.7 35.8-36.7Z",
    fill: "#000"
  })), _react["default"].createElement("defs", null, _react["default"].createElement("clipPath", {
    id: "a"
  }, _react["default"].createElement("path", {
    fill: "#fff",
    d: "M0 0h1023v280.1H0z"
  }))));
};
exports.LogoPayPo = LogoPayPo;
LogoPayPo.defaultProps = {
  viewBox: "0 0 1023 281",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var LogoPayPoWhite = function LogoPayPoWhite(props) {
  return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
    d: "M19.645 30.933V22.74h-8.27v8.193h8.27Z",
    fill: "#A70584"
  }), _react["default"].createElement("path", {
    d: "M19.608 19.884v-8.26h-8.27v8.26h8.27Z",
    fill: "#36B587"
  }), _react["default"].createElement("path", {
    d: "M8.582 30.899v-8.261H.312v8.26h8.27Z",
    fill: "#FAD05B"
  }), _react["default"].createElement("path", {
    d: "M44.298 11.106c0 5.694-4.587 10.278-10.503 10.278h-4.501v9.42h-6.858V.834h11.36c5.915 0 10.502 4.581 10.502 10.272Zm-6.858 0c0-2.185-1.544-3.855-3.645-3.855h-4.501v7.71h4.501c2.1 0 3.645-1.666 3.645-3.855ZM68.22 8.814v21.98h-6.601V28.73c-1.453 1.67-3.609 2.682-6.558 2.682-5.764 0-10.518-5.056-10.518-11.606 0-6.551 4.754-11.606 10.518-11.606 2.95 0 5.1 1.011 6.558 2.683V8.816l6.6-.002Zm-6.601 10.99c0-3.297-2.206-5.363-5.238-5.363-3.032 0-5.237 2.065-5.237 5.362 0 3.298 2.205 5.37 5.237 5.37s5.238-2.072 5.238-5.37ZM93.294 8.813l-7.47 21.174c-2.448 6.942-6.34 9.693-12.456 9.387v-6.113c3.059 0 4.502-.964 5.464-3.622L70.139 8.813h7.211l4.852 13.355L86.31 8.813h6.983ZM117.734 11.106c0 5.694-4.588 10.278-10.504 10.278h-4.501v9.42h-6.858V.834h11.359c5.912 0 10.504 4.581 10.504 10.272Zm-6.859 0c0-2.185-1.544-3.855-3.645-3.855h-4.501v7.71h4.501c2.101 0 3.645-1.666 3.645-3.855ZM118.591 20.103c0-6.38 5.059-11.305 11.36-11.305 6.302 0 11.361 4.925 11.361 11.305s-5.059 11.307-11.361 11.307c-6.301 0-11.36-4.925-11.36-11.307Zm16.29 0c0-3.04-2.143-5.053-4.93-5.053s-4.93 2.013-4.93 5.053 2.143 5.055 4.93 5.055 4.93-2.013 4.93-5.055Z",
    fill: "#fff"
  }));
};
exports.LogoPayPoWhite = LogoPayPoWhite;
LogoPayPoWhite.defaultProps = {
  viewBox: "0 0 142 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var IconFacebook = function IconFacebook(props) {
  return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
    d: "M447.9 386.1V61.8c0-34.1-27.7-61.8-61.8-61.8H61.8C29 0 2.1 25.6.1 57.9V390c1.9 30.9 26.5 55.6 57.3 57.7h128V295.4h-63v-71.7h63v-54.6c0-62.2 37-96.5 93.7-96.5 27.1 0 55.5 4.8 55.5 4.8v61h-31.3c-30.8 0-40.4 19.1-40.4 38.7v46.5h68.8l-11 71.7h-57.8v152.3h127.6c32-2.1 57.4-28.9 57.4-61.5Z",
    fill: "#3B5998"
  }));
};
exports.IconFacebook = IconFacebook;
IconFacebook.defaultProps = {
  width: "448",
  height: "448",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var IconLinkedIn = function IconLinkedIn(props) {
  return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
    d: "M392 0H56C25.1 0 0 25.1 0 56v336c0 30.9 25.1 56 56 56h336c30.9 0 56-25.1 56-56V56c0-30.9-25.1-56-56-56ZM128.5 382.1h-75V156.3h75v225.8ZM90.9 125.5h-.5c-25.2 0-41.5-17.3-41.5-39 0-22.1 16.8-39 42.4-39 25.7 0 41.5 16.9 41.9 39 .2 21.7-16.1 39-42.3 39ZM399 382h-75V261.3c0-30.3-10.9-51-38-51-20.7 0-33.1 14-38.5 27.4-2 4.8-2.5 11.6-2.5 18.3v126h-75s1-204.5 0-225.7h75v32c10-15.4 27.8-37.3 67.6-37.3 49.4 0 86.4 32.3 86.4 101.6V382Z",
    fill: "#2867B2"
  }));
};
exports.IconLinkedIn = IconLinkedIn;
IconLinkedIn.defaultProps = {
  width: "448",
  height: "448",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var IconInstagram = function IconInstagram(props) {
  return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
    d: "M61.8 0h324.3c34.1 0 61.8 27.7 61.8 61.8v324.3c0 34.1-27.7 61.8-61.8 61.8H61.8C27.7 447.9 0 420.2 0 386.1V61.8C0 27.7 27.7 0 61.8 0Z",
    fill: "url(#a)"
  }), _react["default"].createElement("path", {
    d: "M224.6 58.3c-67.6 0-131.8-6-156.3 56.9-10.1 26-8.7 59.7-8.7 108 0 42.4-1.4 82.3 8.7 108 24.5 62.9 89.2 56.9 156.2 56.9 64.7 0 131.4 6.7 156.3-56.9 10.1-26.2 8.7-59.5 8.7-108 0-64.4 3.6-106-27.7-137.3-31.6-31.6-74.4-27.6-137.2-27.6ZM209.8 88c141-.2 158.9-15.9 149 201.8-3.5 77-62.1 68.6-134.2 68.6-131.4 0-135.2-3.8-135.2-135.2C89.5 90.1 99.9 88.1 209.8 88Zm102.9 27.4c-10.9 0-19.8 8.9-19.8 19.8s8.9 19.8 19.8 19.8 19.8-8.9 19.8-19.8c-.1-11-8.9-19.8-19.8-19.8Zm-88.1 23.1c-46.8 0-84.7 37.9-84.7 84.7 0 46.8 37.9 84.7 84.7 84.7 46.8 0 84.7-37.9 84.7-84.7 0-46.8-37.9-84.7-84.7-84.7Zm0 29.7c72.7 0 72.8 110 0 110-72.6 0-72.8-110 0-110Z",
    fill: "#fff"
  }), _react["default"].createElement("defs", null, _react["default"].createElement("linearGradient", {
    id: "a",
    x1: "18.087",
    y1: "429.762",
    x2: "429.787",
    y2: "18.112",
    gradientUnits: "userSpaceOnUse"
  }, _react["default"].createElement("stop", {
    stopColor: "#FD5"
  }), _react["default"].createElement("stop", {
    offset: ".5",
    stopColor: "#FF543E"
  }), _react["default"].createElement("stop", {
    offset: "1",
    stopColor: "#C837AB"
  }))));
};
exports.IconInstagram = IconInstagram;
IconInstagram.defaultProps = {
  width: "448",
  height: "448",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ArrowRight = function ArrowRight(props) {
  return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.667 9a.75.75 0 0 1 .75-.75h10.5a.75.75 0 1 1 0 1.5h-10.5a.75.75 0 0 1-.75-.75Z",
    fill: "#fff"
  }), _react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.136 3.22a.75.75 0 0 1 1.061 0l5.25 5.25a.75.75 0 0 1 0 1.06l-5.25 5.25a.75.75 0 0 1-1.06-1.06L13.856 9l-4.72-4.72a.75.75 0 0 1 0-1.06Z",
    fill: "#fff"
  }));
};
exports.ArrowRight = ArrowRight;
ArrowRight.defaultProps = {
  width: "19",
  height: "18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ButtonLoader = function ButtonLoader(props) {
  return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 2.25A.75.75 0 0 1 9 1.5 7.5 7.5 0 0 1 16.5 9 .75.75 0 0 1 15 9a6 6 0 0 0-6-6 .75.75 0 0 1-.75-.75ZM9.75 15.75a.75.75 0 0 1-.75.75A7.5 7.5 0 0 1 1.5 9 .75.75 0 0 1 3 9a6 6 0 0 0 6 6 .75.75 0 0 1 .75.75Z",
    fill: "#333"
  }));
};
exports.ButtonLoader = ButtonLoader;
ButtonLoader.defaultProps = {
  width: "18",
  height: "18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};